const Style = {
    stack: 'space-y-6',
    header: 'flex flex-wrap items-start justify-between gap-3',
    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
};

export default Style;
